module.exports = __webpack_public_path__ + "static/img/tongguo.9626ef4f.png";